import axios from "axios";
import { alertService } from "@hedgefund/shared/src/Alert";
import { useHistory } from "react-router-dom";

axios.defaults.baseURL = window._env_.BASE_URL;

axios.defaults.headers = {
  Authorization: `Bearer ${
    sessionStorage.getItem("token") ?? localStorage.getItem("token")
  }`,
};

const postUtil = (url, data, baseUrl) =>
  axios.post(url, data, baseUrl ? { baseURL: baseUrl } : null);

const putUtil = (url, data, baseUrl = null) => {
  return axios({
    method: "put",
    url,
    data,
    ...(baseUrl != null && { baseURL: baseUrl }),
  });
};

const patchUtil = (url, data) =>
  axios({
    method: "patch",
    url,
    data,
  });

const getUtil = (url, data = null, baseUrl = null) => {
  const config = {
    ...(baseUrl != null && { baseURL: baseUrl }),
    params: data,
  };

  return axios.get(url, config);
};

const deleteUtil = (url, data = null, baseUrl = null) => {
  const config = {
    ...(baseUrl != null && { baseURL: baseUrl }),
    params: data,
  };
  return axios.delete(url, config);
};
export const setBearerToken = (token) => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  axios.defaults.headers = headers;
};
export const getExportToken = () => {
  // var token= sessionStorage.getItem("token");

  // if(!token)  {
  //   token= localStorage.getItem("token");
  // }

  return null;
};
export const setDefaultHeader = (defaultToken) => {
  const token =
    defaultToken ||
    (sessionStorage.getItem("token") ?? localStorage.getItem("token"));
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  axios.defaults.headers = headers;
};

export { postUtil, getUtil, putUtil, patchUtil, deleteUtil };

axios.interceptors.request.use(
  (config) => {
    config.headers["time-zone"] =
      Intl.DateTimeFormat().resolvedOptions().timeZone;
    return config;
  },
  (error) => {
    console.log(error, "ERROR FOUND IN REQEST");
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { data } = error.response;
    if (error?.response?.status === 401) {
      localStorage.clear();
      let history = useHistory();
      history.push("/login");
    } else if (error?.response?.config?.url === "/TokenAuth/Authenticate") {
      if (data.error.message == "Your Account Status is not Active") {
        return data.error.message;
      }
      return alertService.error(data?.error?.message);
    } else if (error?.response?.config?.url === "/TokenAuth/Authenticate") {
      return alertService.error(data?.error?.message);
    } else if (error?.response?.status === 500) {
      return alertService.error(
        "500 Internal Server Error Oh no! Our shoe came untied! Your data is safe. Please come back later when we fixed that problem. Thanks."
      );
    } else {
      alertService.error(data.error.message);
    }
    return error.response;
  }
);
